"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplyFade = void 0;
require("./main.css");
var SimplyFade = /** @class */ (function () {
    function SimplyFade(options) {
        var _this = this;
        options = options || {};
        var attributeSelector = options.attributeSelector || 'simply-fade';
        var offsetPx = options.offsetPx || 200;
        var transitionDuration = options.transitionDuration || 0.5;
        var movementPx = options.movementPx || 50;
        this.animatedElements = Array.from(document.querySelectorAll("*[".concat(attributeSelector, "]")));
        if (!this.animatedElements.length)
            return;
        for (var i = 0; i < this.animatedElements.length; i++) {
            var elem = this.animatedElements[i];
            var direction = elem.getAttribute(attributeSelector) || 'fade';
            this.applyDirectionalStyles(elem, direction, movementPx);
            if (this.isValidTransitionNumber(transitionDuration)) {
                elem.style.transition = "".concat(transitionDuration, "s all ease-out");
            }
            else {
                elem.style.transition = '.5s all ease-out';
                console.warn('SimplyFade: Invalid transition duration provided. Defaulting to .5s');
            }
        }
        var handleScroll = function () {
            for (var i = 0; i < _this.animatedElements.length; i++) {
                var elem = _this.animatedElements[i];
            }
            for (var i = 0; i < _this.animatedElements.length; i++) {
                var elem = _this.animatedElements[i];
                if (_this.isElemVisible(elem, offsetPx)) {
                    elem.style.opacity = '1';
                    elem.style.transform = 'scale(1)';
                    _this.animatedElements.splice(i, 1);
                }
            }
        };
        handleScroll();
        document.addEventListener('scroll', handleScroll);
    }
    SimplyFade.prototype.isElemVisible = function (el, offsetPx) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top + offsetPx;
        var elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    };
    SimplyFade.prototype.applyDirectionalStyles = function (el, direction, movementPx) {
        el.style.opacity = '0';
        switch (direction) {
            case 'up':
                el.style.transform = "translateY(".concat(movementPx, "px)");
                break;
            case 'down':
                el.style.transform = "translateY(-".concat(movementPx, "px)");
                break;
            case 'left':
                el.style.transform = "translateX(".concat(movementPx, "px)");
                break;
            case 'right':
                el.style.transform = "translateX(-".concat(movementPx, "px)");
                break;
            case 'fade':
                el.style.transform = "scale(1)";
                break;
            default:
                console.warn('SimplyFade: Invalid direction provided');
                break;
        }
    };
    SimplyFade.prototype.isValidTransitionNumber = function (n) {
        return (n - 0) * (n - 1) <= 0;
    };
    return SimplyFade;
}());
exports.SimplyFade = SimplyFade;
